import React from "react";

export default function ScanToSvgIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="115"
            height="115"
            viewBox="0 0 115 115"
            {...props}
        >
            <g transform="translate(-26 -45)">
                <circle
                    cx="57.5"
                    cy="57.5"
                    r="57.5"
                    transform="translate(26 45)"
                    fill={props.stopColor}
                />
                <g transform="translate(56 75)">
                    {/* QR Code Frame */}
                    <path
                        d="M0 4C0 1.79086 1.79086 0 4 0H16V4H4V16H0V4Z"
                        fill={props.fill}
                    />
                    <path
                        d="M0 51V39H4V51H16V55H4C1.79086 55 0 53.2091 0 51Z"
                        fill={props.fill}
                    />
                    <path
                        d="M51 0H39V4H51V16H55V4C55 1.79086 53.2091 0 51 0Z"
                        fill={props.fill}
                    />
                    <path
                        d="M51 55H39V51H51V39H55V51C55 53.2091 53.2091 55 51 55Z"
                        fill={props.fill}
                    />
                    {/* Scan Line */}
                    <rect x="8" y="26" width="39" height="3" rx="1.5" fill={props.fill} />
                    {/* QR Code Elements */}
                    <rect x="12" y="12" width="10" height="10" rx="2" fill={props.fill} />
                    <rect x="33" y="12" width="10" height="10" rx="2" fill={props.fill} />
                    <rect x="12" y="33" width="10" height="10" rx="2" fill={props.fill} />
                    <rect x="33" y="33" width="5" height="5" rx="1" fill={props.fill} />
                    <rect x="40" y="33" width="3" height="10" rx="1" fill={props.fill} />
                    <rect x="33" y="40" width="10" height="3" rx="1" fill={props.fill} />
                </g>
            </g>
        </svg>
    );
}
